import React from 'react';

interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

const BottomSeminarIcon: React.FC<IconProps> = ({ width = 24, height = 24, color = 'currentColor' }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="3" y="4" width="18" height="18" rx="2" stroke={color} strokeWidth="1.5" fill="none"/>
    <line x1="3" y1="10" x2="21" y2="10" stroke={color} strokeWidth="1.5"/>
    <line x1="8" y1="4" x2="8" y2="2" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <line x1="16" y1="4" x2="16" y2="2" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <rect x="7" y="14" width="4" height="4" rx="0.5" stroke={color} strokeWidth="1.2" fill="none"/>
  </svg>
);

export default BottomSeminarIcon;
